import type { WidgetStaticProps } from '@swf/core/types/Widget';
import widgets from '@swf/widgets/index';

export const fetchProperties = async (type: string): Promise<WidgetStaticProps> =>
  widgets[type] ? (await widgets[type].preload()).default : {};
